import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { MainContext } from "../../../../main/context/MainContextProvider";

export type DesvioPeriodoCardProps = {
    deviation: number;
    deviationPercentage: number;
};

export default function DesvioPeriodoCard({
    deviation,
    deviationPercentage
}: DesvioPeriodoCardProps) {
    const { theme } = useContext(MainContext);

    const getColors = () => {
        if (deviation > 0) return { bg: "rgba(16, 185, 129, 0.1)", text: "#10B981" };
        if (deviationPercentage >= 100) return { bg: "rgba(16, 185, 129, 0.1)", text: "#10B981" };
        if (deviationPercentage >= 95) return { bg: "rgba(251, 191, 36, 0.1)", text: "#F59E0B" };
        return { bg: "rgba(239, 68, 68, 0.1)", text: "#EF4444" };
    };

    const colors = getColors();

    return (
        <Box
            sx={{
                marginTop: "12px",
                padding: "14px",
                backgroundColor: colors.bg,
                borderRadius: "6px",
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <Typography sx={{ fontSize: "12px", color: theme.secondaryTextColor }}>
                    Desvio do Período
                </Typography>
                <Typography
                    sx={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: colors.text
                    }}
                >
                    {deviation > 0 ? "+" : ""}{deviation.toFixed(1)} MWh
                </Typography>
            </Box>
            <Box>
                <Typography sx={{ fontSize: "12px", fontWeight: "700", color: colors.text, textAlign: "left" }}>
                    {Number.isFinite(deviationPercentage) && deviationPercentage > 0 ? deviationPercentage.toFixed(1) : 0}% da meta atingida
                </Typography>
            </Box>
        </Box>
    );
}
